import { useSelector } from "@tanstack/react-store"
import { createStore } from "@tanstack/store"
import { registerSessionCleanup } from "@/shared/lib/auth"

const highlightedThoughtsStore = createStore<ReadonlySet<number>>(
	new Set<number>(),
)

export function highlightThought(thoughtId: number): void {
	highlightedThoughtsStore.setState((ids) => new Set(ids).add(thoughtId))
}

export function unhighlightThought(thoughtId: number): void {
	highlightedThoughtsStore.setState((ids) => {
		const next = new Set(ids)
		next.delete(thoughtId)
		return next
	})
}

export function clearHighlightedThoughts(): void {
	highlightedThoughtsStore.setState(() => new Set<number>())
}

registerSessionCleanup(clearHighlightedThoughts)

export function useHighlightedThoughtIds(): ReadonlySet<number> {
	return useSelector(highlightedThoughtsStore)
}
